import controller from './order-detail.controller';
import templateBase from './templates/order-detail-base.view.html';
import templateAD from './templates/order-detail-adaptative.html';

let OrderDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    if(__env.adaptative) {
        return templateAD;
    } else {  
        return templateBase;
    }

}

export default OrderDetailComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/order-detail/order-detail.component.js
 **/